const TRC_FILE_TYPE = Object.freeze({
	ALL: '',
	PDF: 'pdf',
	VIDEO: 'video'
});

export const TRC_FILE_TYPE_LABELS = Object.freeze({
	ALL: 'All Types',
	PDF: 'PDF',
	VIDEO: 'Video'
});
export default TRC_FILE_TYPE;
